<template>
  <div class="fixed inset-0 bg-background/90 backdrop-blur flex items-center justify-center z-50">
    <div class="text-center">
      <div
        :class="[
          'text-9xl font-bold transition-all duration-300',
          secondsRemaining <= 1 ? 'text-primary scale-150' : 'text-text-primary'
        ]"
      >
        {{ secondsRemaining > 0 ? secondsRemaining : 'GO!' }}
      </div>
      <p class="text-text-secondary text-xl mt-4">Get ready...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  secondsRemaining: number;
}>();
</script>
